module.exports = __webpack_public_path__ + "static/media/goods_bg.9e6174c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/goods_bg.png
// module id = 397
// module chunks = 0